import { images, resort } from "@/data/resort";
import { ResortLink } from "../resort-button";

export function MapFinalCTA() {
  return (
    <section aria-labelledby="map-final-cta-heading" className="relative overflow-hidden bg-primary py-16 md:py-20">
      <div className="overlay-cinematic absolute inset-0" />
      <div className="shell relative max-w-3xl text-center text-primary-foreground">
        <p className="eyebrow text-primary-foreground/75">Found Your Base Camp?</p>
        <h2 id="map-final-cta-heading" className="display-lg mt-6">
          Now Let&apos;s Find Your Available Site
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-primary-foreground/80">
          Tell us when you&apos;re traveling and what you&apos;re bringing. Auburn RV Resort will
          review your request and help identify the best available site for your stay.
        </p>
        <div className="mt-10 flex flex-col justify-center gap-3 sm:flex-row">
          <ResortLink variant="gold" href="/reservations/" className="w-full sm:w-auto">
            Check Availability
          </ResortLink>
          <ResortLink variant="onDark" href={resort.phoneHref} className="w-full sm:w-auto">
            Call the Resort
          </ResortLink>
        </div>
        <p className="eyebrow mt-8 text-primary-foreground/60">
          71 Sites · Full Hookups · Pull-Through · Back-In · Accessible
        </p>
      </div>
    </section>
  );
}
